import gql from "graphql-tag";

const DELETE_NAVSLOT_MUTATION = gql`  
  mutation deleteNav($navSlotId: String!) {
  deleteNavSlot(id: $navSlotId){
    id
  }
}
`;

export default DELETE_NAVSLOT_MUTATION;